import _typeof from "@babel/runtime/helpers/typeof";
export var SYNCED_BLOCK_EXTENSION_TYPE = 'com.atlassian.platform.extensions';
export var SYNCED_BLOCK_EXTENSION_KEY = 'synced-block';
export var SYNCED_BLOCK_SOURCE_NODE = 'source';
export var SYNCED_BLOCK_SOURCE_KEY = "".concat(SYNCED_BLOCK_EXTENSION_KEY, ":").concat(SYNCED_BLOCK_SOURCE_NODE);
export var SYNCED_BLOCK_REFERENCE_NODE = 'reference';
export var SYNCED_BLOCK_REFERENCE_KEY = "".concat(SYNCED_BLOCK_EXTENSION_KEY, ":").concat(SYNCED_BLOCK_REFERENCE_NODE);
export var isSyncedBlockAttributes = function isSyncedBlockAttributes(attributes) {
  return !!attributes && _typeof(attributes) === 'object' && 'extensionKey' in attributes && (attributes.extensionKey === SYNCED_BLOCK_SOURCE_KEY || attributes.extensionKey === SYNCED_BLOCK_REFERENCE_KEY);
};
export var getDefaultSyncedBlockContent = function getDefaultSyncedBlockContent() {
  var attributes = {
    extensionType: SYNCED_BLOCK_EXTENSION_TYPE,
    extensionKey: SYNCED_BLOCK_SOURCE_KEY,
    parameters: {
      sourceDocumentAri: '',
      contentAri: '',
      contentPropertyKey: ''
    },
    localId: ''
  };
  return {
    type: 'bodiedExtension',
    attrs: attributes,
    content: [{
      type: 'paragraph',
      content: [{
        type: 'text',
        text: 'This is a synced block. Please edit the source document to update the content.'
      }]
    }]
  };
};
export var parseSyncedBlockContentPropertyValue = function parseSyncedBlockContentPropertyValue(value) {
  try {
    if (typeof value === 'string') {
      return JSON.parse(value);
    }
    return value;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to parse synced block content:', error);
    return {
      adf: getDefaultSyncedBlockContent()
    };
  }
};
export var stringifySyncedBlockContentPropertyValue = function stringifySyncedBlockContentPropertyValue(value) {
  try {
    return JSON.stringify(value);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to serialize synced block content:', error);
    return JSON.stringify({
      adf: getDefaultSyncedBlockContent()
    });
  }
};